import * as React from 'react';
import { createTheme } from '@mui/material/styles';
import { AppProvider, Navigation, Router } from '@toolpad/core/AppProvider';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';
import { PageContainer } from '@toolpad/core';
import { BillingIcon, Notification, NotificationCancel, ProfileIcon, RightArrowWithLine, SignOut } from '../../assets/icons';
import { AvatarImg, dummyProfile, easyCRMSoloLogo, easywebinarSoloLogo, greenTimer, Logo, pinkTimer, purpleTimer, } from '../../assets/images';

import { Box, IconButton, Menu, Typography, Button, Avatar, Link } from '@mui/material';
import Grid from '@mui/material/Grid2';
import OverViewIcon from '../../assets/icons/overviewIcon';
import { HelpOutline } from '@mui/icons-material';
const EasysuiteWelcomeDashboard = () => {
    const NAVIGATION: Navigation = [
        {
            icon: <>
                <Box className="sidebar-profile-wrapper" borderBottom='1px solid #F3F3F3' p='17px' textAlign="center">
                    <Avatar alt="Remy Sharp" src={dummyProfile} sx={{ width: 75, height: 75 }} />
                    <Box textAlign="center" mt="10px" color='#444444' sx={{ wordWrap: "break-word" }}>
                        <Typography mb='4px' fontSize='12px'>Welcome</Typography>
                        <Typography mb='8px' fontSize='16px' fontWeight="600">RYAN LEE</Typography>
                        <Typography color='#89898A !important' fontSize='14px' component={"p"}>RyanLeeForever@gmail.com</Typography>
                    </Box>
                </Box>
            </>,
            segment: '',
        },

    ];

    const useDemoRouter = (initialPath: string): Router => {
        const [pathname, setPathname] = React.useState(initialPath);

        const router = React.useMemo(() => {
            const url = new URL(pathname, window.location.origin);
            return {
                pathname: url.pathname,
                searchParams: url.searchParams,
                navigate: (path: string | URL) => setPathname(String(path)),
            };
        }, [pathname]);

        return router;
    };

    function ToolbarActionsSearch() {
        const [anchorElNotification, setAnchorElNotification] = React.useState<null | HTMLElement>(null);
        const [anchorElOverlay, setAnchorElOverlay] = React.useState<null | HTMLElement>(null);
        const [anchorElProfile, setAnchorElProfile] = React.useState<null | HTMLElement>(null);

        const handleMenuOpenNotification = (event: React.MouseEvent<HTMLElement>) => {
            setAnchorElNotification(event.currentTarget);
        };

        const handleMenuCloseNotification = () => {
            setAnchorElNotification(null);
        };

        const handleMenuOpenOverlay = (event: React.MouseEvent<HTMLElement>) => {
            setAnchorElOverlay(event.currentTarget);
        };

        const handleMenuCloseOverlay = () => {
            setAnchorElOverlay(null);
        };

        const handleMenuOpenProfile = (event: React.MouseEvent<HTMLElement>) => {
            setAnchorElProfile(event.currentTarget);
        };

        const handleMenuCloseProfile = () => {
            setAnchorElProfile(null);
        };

        return (
            <Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <IconButton onClick={handleMenuOpenNotification} sx={{ "& svg rect:hover": { fill: '#f2f2f2' }, "& svg:hover path": { fill: '#0C23FF' }, padding: '0', marginRight: "12px" }}>
                            <Notification />
                        </IconButton>
                        <Menu
                            anchorEl={anchorElNotification}
                            open={Boolean(anchorElNotification)}
                            onClose={handleMenuCloseNotification}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                            sx={{ '& .MuiMenu-paper': { borderRadius: "12px !important", boxShadow: "0px 12px 20px 0px #0D0E213D" } }}
                        >
                            <Typography color='#333335' fontSize='16px' mb='19px' borderBottom='1px solid #F3F3F3' p='14px'>
                                Notifications
                            </Typography>
                            <Box display="flex" px='10px' alignItems="center" justifyContent='space-between' borderBottom='1px solid #F3F3F3' pb='11px' mb='10px'>
                                <Box display="flex">
                                    <Box borderRadius="50%" bgcolor="#26BF941A" height="40px" width="40px" display="flex" justifyContent="center" alignItems="center" marginRight="8px">
                                        <img src={greenTimer} alt="clock-img" />
                                    </Box>
                                    <Box>
                                        <Typography color='#232323' fontSize='14px' lineHeight='24px'>Plan Changed</Typography>
                                        <Typography color='#8C9097' fontSize='12px' lineHeight='18px'>Your plan has been changed to “Evergree..</Typography>
                                    </Box>
                                </Box>
                                <NotificationCancel />
                            </Box>
                            <Box display="flex" px='10px' alignItems="center" justifyContent='space-between' borderBottom='1px solid #F3F3F3' pb='11px' mb='10px'>
                                <Box display="flex">
                                    <Box borderRadius="50%" bgcolor="#E791BC1A" height="40px" width="40px" display="flex" justifyContent="center" alignItems="center" marginRight="8px">
                                        <img src={pinkTimer} alt="clock-img" />
                                    </Box>
                                    <Box>
                                        <Typography color='#232323' fontSize='14px' lineHeight='24px'>Subscription Expired</Typography>
                                        <Typography color='#8C9097' fontSize='12px' lineHeight='18px'>Your Subscription has expired</Typography>
                                    </Box>
                                </Box>
                                <NotificationCancel />
                            </Box>
                            <Box display="flex" px='10px' alignItems="center" justifyContent='space-between' borderBottom='1px solid #F3F3F3' pb='11px' mb='10px'>
                                <Box display="flex">
                                    <Box borderRadius="50%" bgcolor="#845ADF1A" height="40px" width="40px" display="flex" justifyContent="center" alignItems="center" marginRight="8px">
                                        <img src={purpleTimer} alt="clock-img" />
                                    </Box>
                                    <Box>
                                        <Typography color='#232323' fontSize='14px' lineHeight='24px'>Black Friday Deals</Typography>
                                        <Typography color='#8C9097' fontSize='12px' lineHeight='18px'>Get 50% off on all plans this season</Typography>
                                    </Box>
                                </Box>
                                <NotificationCancel />
                            </Box>
                            <Box p='16px' mt='105px' position='sticky' bottom='0' bgcolor='#FFf'>
                                <Button variant="contained" size="large" sx={{ width: '100%', textTransform: 'capitalize' }}>View All</Button>
                            </Box>
                        </Menu>
                    </Box>
                    <Box>
                        <IconButton onClick={handleMenuOpenProfile} sx={{ '&:hover': { bgcolor: '#fff' }, padding: '0' }}>
                            <Avatar alt="Remy Sharp" src={AvatarImg} />
                        </IconButton>
                        <Menu
                            anchorEl={anchorElProfile}
                            open={Boolean(anchorElProfile)}
                            onClose={handleMenuCloseProfile}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            sx={{ '& .MuiMenu-paper': { borderRadius: "12px !important", boxShadow: "0px 12px 20px 0px #0D0E213D" } }}
                        >
                            <Box display="flex" borderBottom='1px solid #F3F3F3' p='17px'>
                                <Avatar alt="Remy Sharp" src={AvatarImg} />
                                <Box ml='16px' >
                                    <Typography mb='4px' color='#0F0F0F' fontSize='16px'>Ryan Lee</Typography>
                                    <Typography color='#666666' fontSize='16px'>RyanLee091@gmail.com</Typography>
                                </Box>

                            </Box>
                            <Box display='flex' p='8px 16px' mt='8px' alignItems='center' sx={{ '&:hover': { bgcolor: '#F3F6F8' } }}>
                                <ProfileIcon></ProfileIcon>
                                <Typography color='#0F0F0F' ml='16px' fontSize='14px'>Manage Profile</Typography>

                            </Box>
                            <Box display='flex' p='8px 16px' alignItems='center' sx={{ '&:hover': { bgcolor: '#F3F6F8' } }}>
                                <SignOut></SignOut>
                                <Typography color='#0F0F0F' ml='16px' fontSize='14px'>Sign out</Typography>
                            </Box>
                        </Menu>
                    </Box>
                </Box>
            </Box>
        );
    }

    const router = useDemoRouter('/');
    console.log("router", router);

    const demoTheme = createTheme({
        cssVariables: {},
        colorSchemes: { light: true }
    });


    return (
        <Box className='dashboard-wrapper easysuite-dashboard-wrapper'>
            <AppProvider navigation={NAVIGATION} router={router} branding={{
                logo: (
                    <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                        <img src={Logo} alt="logo" />
                    </Box>
                ),
                title: '',
            }} theme={demoTheme}>
                <DashboardLayout
                    disableCollapsibleSidebar
                    sidebarExpandedWidth="232px"
                    slots={{
                        toolbarActions: ToolbarActionsSearch,
                    }}
                    sx={
                        { bgcolor: '#FAFAFA' }
                    }
                >
                    <PageContainer breadcrumbs={[]} title='' sx={{
                        maxWidth: { lg: "1378px" }, "& nav[aria-label='breadcrumb']": {
                            display: "none"
                        }
                    }}
                        className='easysuite-content-container'>
                        <Box className='easysuite-content'>
                            <Box className="product-box-wrapper" sx={{ gap: { xs: "24px", md: "32px", lg: "90px", xl: "95px" } }}>
                                <Box className="product-box">
                                    <Box component="span" className="product-logo" display="flex" justifyContent="center">
                                        <img src={easywebinarSoloLogo} alt="easywebinar logo" />
                                    </Box>
                                    <Box className="product-title">
                                        <Box className='easywebinar-text-logo'>Easy<span className="primary-green-text">Webinar</span></Box>
                                    </Box>
                                    <Box className="product-nav-list">
                                        <a href="#">My Webinar</a>
                                        <Box component="span">|</Box>
                                        <a href="#">My Dashboard</a>
                                    </Box>
                                </Box>
                                <Box className="product-box">
                                    <Box component="span" className="product-logo" display="flex" justifyContent="center">
                                        <img src={easyCRMSoloLogo} alt="easyCRM logo" />
                                    </Box>
                                    <Box className="product-title">
                                        <Box className='easyCRM-text-logo'>Easy<span className='primary-purple-text'>CRM</span></Box>
                                    </Box>
                                    <Box className="product-nav-list">
                                        <a href="#">My leads</a>
                                        <Box component="span">|</Box>
                                        <a href="#">My Dashboard</a>
                                    </Box>
                                </Box>
                            </Box>
                            <Grid container rowSpacing={{ xs: 3, sm: 3, md: 3 }} columnSpacing={{ xs: 3, sm: 2, md: 3 }} justifyContent="center" className="sub-menu-cards" mt={{ xs: "42px", md: "52px", xl: "140px" }}>
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4 }}>
                                    <Box borderRadius="12px" color="#555555" height="100%" border="1px solid #E8EAF0" bgcolor="#FFF" p="20px 20px 30px" sx={{
                                        "&:hover": {
                                            boxShadow: "0px 4px 24px 0px rgba(43, 43, 48, 0.16)"
                                        }
                                    }}>
                                        <Box display="flex" alignItems="center" gap="12px" mb="8px"><OverViewIcon /><Typography variant="h6" color="inherit" fontSize="min(calc(14px + 4 * (100vw - 400px) / (1920 - 400)), 18px)" lineHeight="140% ">OVERVIEW</Typography></Box>
                                        <Typography variant='body2' color="inherit">Manage your account and preferences</Typography>
                                        <Box mt="16px">
                                            <Link href="/overview" fontSize="min(calc(12px + 2 * (100vw - 400px) / (1920 - 400)), 14px)" display="flex" alignItems="center" gap="4px" color='#178EFC' sx={{ textDecoration: "none", "&:hover": { textDecoration: "underline" } }}>Manage Account <RightArrowWithLine /></Link>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4 }}>
                                    <Box borderRadius="12px" color="#555555" height="100%" border="1px solid #E8EAF0" bgcolor="#FFF" p="20px 20px 30px" sx={{
                                        "&:hover": {
                                            boxShadow: "0px 4px 24px 0px rgba(43, 43, 48, 0.16)"
                                        }
                                    }}>
                                        <Box display="flex" alignItems="center" gap="12px" mb="8px"><BillingIcon /><Typography variant="h6" color="inherit" fontSize="min(calc(14px + 4 * (100vw - 400px) / (1920 - 400)), 18px)" lineHeight="140% ">BILLING</Typography></Box>
                                        <Typography variant='body2' color="inherit">Manage payment info and billing invoices</Typography>
                                        <Box mt="16px">
                                            <Link href="/overview" fontSize="min(calc(12px + 2 * (100vw - 400px) / (1920 - 400)), 14px)" display="flex" alignItems="center" gap="4px" color='#178EFC' sx={{ textDecoration: "none", "&:hover": { textDecoration: "underline" } }}>Billing<RightArrowWithLine /></Link>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4 }}>
                                    <Box borderRadius="12px" color="#555555" height="100%" border="1px solid #E8EAF0" bgcolor="#FFF" p="20px 20px 30px" sx={{
                                        "&:hover": {
                                            boxShadow: "0px 4px 24px 0px rgba(43, 43, 48, 0.16)"
                                        }
                                    }}>
                                        <Box display="flex" alignItems="center" gap="12px" mb="8px"><HelpOutline sx={{ fontSize: "21px" }} /><Typography variant="h6" color="inherit" fontSize="min(calc(14px + 4 * (100vw - 400px) / (1920 - 400)), 18px)" lineHeight="140% ">HELP</Typography></Box>
                                        <Typography variant='body2' color="inherit">Get 24/7 customer support</Typography>
                                        <Box mt="16px">
                                            <Link href="/overview" fontSize="min(calc(12px + 2 * (100vw - 400px) / (1920 - 400)), 14px)" display="flex" alignItems="center" gap="4px" color='#178EFC' sx={{ textDecoration: "none", "&:hover": { textDecoration: "underline" } }}>Help Center<RightArrowWithLine /></Link>
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </PageContainer>
                </DashboardLayout>
            </AppProvider>
        </Box >
    );
};

export default EasysuiteWelcomeDashboard;
